/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CRSFSecReviewDomainExpansionTicketData } from './CRSFSecReviewDomainExpansionTicketData';
import {
    CRSFSecReviewDomainExpansionTicketDataFromJSON,
    CRSFSecReviewDomainExpansionTicketDataFromJSONTyped,
    CRSFSecReviewDomainExpansionTicketDataToJSON,
} from './CRSFSecReviewDomainExpansionTicketData';
import type { CRSFSecReviewScanType } from './CRSFSecReviewScanType';
import {
    CRSFSecReviewScanTypeFromJSON,
    CRSFSecReviewScanTypeFromJSONTyped,
    CRSFSecReviewScanTypeToJSON,
} from './CRSFSecReviewScanType';

/**
 * 
 * @export
 * @interface CRSFSecReviewDomainExpansionTicketResponse
 */
export interface CRSFSecReviewDomainExpansionTicketResponse {
    /**
     * 
     * @type {CRSFSecReviewDomainExpansionTicketData}
     * @memberof CRSFSecReviewDomainExpansionTicketResponse
     */
    data?: CRSFSecReviewDomainExpansionTicketData;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainExpansionTicketResponse
     */
    process_id: string;
    /**
     * 
     * @type {CRSFSecReviewScanType}
     * @memberof CRSFSecReviewDomainExpansionTicketResponse
     */
    scan_type: CRSFSecReviewScanType;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainExpansionTicketResponse
     */
    status: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewDomainExpansionTicketResponse
     */
    ticket: string;
}

/**
 * Check if a given object implements the CRSFSecReviewDomainExpansionTicketResponse interface.
 */
export function instanceOfCRSFSecReviewDomainExpansionTicketResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "scan_type" in value;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "ticket" in value;

    return isInstance;
}

export function CRSFSecReviewDomainExpansionTicketResponseFromJSON(json: any): CRSFSecReviewDomainExpansionTicketResponse {
    return CRSFSecReviewDomainExpansionTicketResponseFromJSONTyped(json, false);
}

export function CRSFSecReviewDomainExpansionTicketResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewDomainExpansionTicketResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CRSFSecReviewDomainExpansionTicketDataFromJSON(json['data']),
        'process_id': json['process_id'],
        'scan_type': CRSFSecReviewScanTypeFromJSON(json['scan_type']),
        'status': json['status'],
        'ticket': json['ticket'],
    };
}

export function CRSFSecReviewDomainExpansionTicketResponseToJSON(value?: CRSFSecReviewDomainExpansionTicketResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CRSFSecReviewDomainExpansionTicketDataToJSON(value.data),
        'process_id': value.process_id,
        'scan_type': CRSFSecReviewScanTypeToJSON(value.scan_type),
        'status': value.status,
        'ticket': value.ticket,
    };
}

